
import React, { useState, useEffect } from 'react';
import { cn } from '@/lib/utils';
import { Progress } from '@/components/ui/progress';

interface ReadingProgressBarProps {
  isLoading?: boolean;
  className?: string;
  color?: string;
}

export function ReadingProgressBar({ 
  isLoading = false, 
  className,
  color = 'bg-primary'
}: ReadingProgressBarProps) {
  const [progress, setProgress] = useState(0);
  
  useEffect(() => {
    if (isLoading) {
      // Start with initial progress
      setProgress(10);
      
      // Simulate progress incrementally to give sense of loading
      const timer1 = setTimeout(() => setProgress(30), 200);
      const timer2 = setTimeout(() => setProgress(50), 500);
      const timer3 = setTimeout(() => setProgress(70), 800);
      const timer4 = setTimeout(() => setProgress(90), 1200);
      
      return () => {
        clearTimeout(timer1);
        clearTimeout(timer2);
        clearTimeout(timer3);
        clearTimeout(timer4);
      };
    } else {
      // When loading is complete, quickly finish the progress
      setProgress(100);
      
      // Reset after animation completes
      const resetTimer = setTimeout(() => {
        setProgress(0);
      }, 500);
      
      return () => {
        clearTimeout(resetTimer);
      };
    }
  }, [isLoading]);
  
  if (progress === 0) return null;
  
  return (
    <div className={cn("fixed top-0 left-0 right-0 z-50 h-1", className)}>
      <Progress 
        value={progress} 
        className={cn("h-1 rounded-none", progress === 100 ? "transition-opacity duration-500 opacity-0" : "opacity-100")}
      />
    </div>
  );
}
